import React from "react";
import {usePage} from "../../Context/PageContext"
import { useQuery } from "react-query";
import './CGU.css';
import fetchPageById from "../../Data/page_service";
export const CGU = () => {
  const {page , setPageAttributes}=usePage()
  useQuery('pageById', () => fetchPageById(setPageAttributes , 'cgu'));

  return (
    <div className="cg">
      {page && <div dangerouslySetInnerHTML={{ __html:  page.contenu}} />}
    </div>
  );
};